/**
 * Progressive US phone masking for the additional-info form.
 *
 * Mirrors the main form's phone UX (see
 * `src/formatting/events/handlers/input-handler.ts` formatPhone), but lives in
 * the additional-info module because the host is opted out of the global
 * format-engine (`data-no-format="true"` — required so the bank/account/
 * routing/license digit fields aren't mangled by phone/SSN/currency
 * auto-detection). The Work Phone field opts back IN to phone masking here.
 */

/**
 * Apply progressive (XXX) XXX-XXXX masking to a raw input string.
 *
 *   ''         → ''
 *   '5'        → '(5'
 *   '555'      → '(555'
 *   '5555'     → '(555) 5'
 *   '5555551'  → '(555) 555-1'
 *   '5555551234' → '(555) 555-1234'
 *   '55555512349' → '(555) 555-1234' (capped at 10 digits)
 */
export function applyPhoneMask(raw: string): string {
  const digits = (raw || '').replace(/\D/g, '').substring(0, 10);
  if (digits.length === 0) return '';
  if (digits.length <= 3) return `(${digits}`;
  if (digits.length <= 6) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
}
